"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehiclesReducer = void 0;
const vehicles_1 = require("../actions/vehicles");
const initState = [];
const vehiclesReducer = (vehicles = initState, action) => {
    switch (action.type) {
        case vehicles_1.SET_VEHICLES:
            const previousIdMap = new Map(vehicles.map((item) => [item.id, Object.assign({}, item)]));
            const newArray = action.payload || [];
            newArray.forEach((item) => previousIdMap.set(item.id, item));
            const resultArray = [...previousIdMap.values()];
            resultArray.sort((a, b) => (a.id > b.id ? 1 : -1));
            return resultArray;
        default:
            return vehicles;
    }
};
exports.vehiclesReducer = vehiclesReducer;
//# sourceMappingURL=vehicles.reducer.js.map